import React, { FC } from 'react';
import { Marker as RGMMarker, MarkerProps } from 'react-google-maps';

interface IProps {
  position:
    | {
        lat: number;
        lng: number;
      }
    | google.maps.LatLng;
  icon?: string;
  size?: {
    x: number;
    y: number;
  };
  anchor?: google.maps.Point;
  options?: google.maps.MarkerOptions;
  onClick?: (e: google.maps.MouseEvent) => void;
}

const Marker: FC<IProps & MarkerProps> = ({ position, size = null, icon, anchor, options = {}, ...props }) => {
  const scaledSize = size ? { scaledSize: new google.maps.Size(size.x, size.y) } : {};
  return (
    <RGMMarker
      cursor="default"
      position={position}
      options={{
        icon: icon
          ? {
              url: icon,
              ...scaledSize,
              anchor,
            }
          : undefined,
        optimized: false,
        ...options,
      }}
      {...props}
    />
  );
};

export default Marker;
